<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.static_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date(Static)" end-placeholder="End date(Static)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.save_time" type="daterange" size="small" value-format="yyyy-MM-dd" align="right"
          unlink-panels start-placeholder="Start date(Save)" end-placeholder="End date(Save)"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Add</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 962px;">
      <el-table-column prop="id" label="Id" width="80" align="center">
      </el-table-column>
      <el-table-column prop="country" label="Country" width="100">
      </el-table-column>
      <el-table-column prop="business_name" label="Business name" width="120">
      </el-table-column>
      <el-table-column prop="balance" label="Balance" width="160">
      </el-table-column>
      <el-table-column prop="static_time" label="Static time" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.static_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="save_time" label="Save time" width="200">
        <template slot-scope="scope">
          <div>{{scope.row.save_time|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Action" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="160px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Country/Business">
          <el-cascader :options="country_business" size="small"
            :props="{ checkStrictly: true,value:'name',label:'name',expandTrigger: 'hover'}" clearable
            placeholder="Country/Business" @change="cascaderEditForm" style="position:relative;right:2px"
            :disabled="title=='Edit'">
          </el-cascader>
        </el-form-item>
        <el-form-item label="Static Time">
          <el-date-picker v-model="editForm.static_time" type="date" placeholder="Static Time" value-format="yyyy-MM-dd"
            clearable :picker-options="pickerOptions" :disabled="title=='Edit'">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Balance" prop="balance">
          <el-input size="small" type="number" v-model="editForm.balance" auto-complete="off" placeholder="Balance"
            clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    businessBalanceList,
    businessBalanceSave,
    getCountryBusiness
  } from '../../api/apiFun'
  import {
    cascaderChange,
    timestampToTime
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        editForm: {
          id: '',
          static_time: '',
          country: '',
          business_name: '',
          balance: ''
        },
        // rules 表单验证
        rules: {
          static_time: [{
            required: true,
            message: 'Please enter the static_time',
            trigger: 'blur'
          }],
          balance: [{
            required: true,
            message: 'Please enter the balance',
            trigger: 'blur'
          }],
        },
        pickerOptions: {},
        params: {
          page: 1,
          limit: 10,
          static_time: '',
          save_time: '',
          country: '',
          business_name: '',
        },
        listData: [],
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        country_business: []
      }
    },
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      }
    },
    created() {
      this.getCountryBusiness()
      this.getdata(this.params)
    },
    methods: {
      timestampToTimeM: function (timestamp) {
        var time = timestampToTime(timestamp)
        var date = time.split(" ")
        return date[0]
      },
      getCountryBusiness() {
        getCountryBusiness().then(res => {
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            this.country_business = res.datas;
          }
        }).catch(err => {
          this.$message.error('Failed to obtain business list, please try again later!')
        })
      },
      cascaderEditForm(value) {
        var cascader = cascaderChange(value)
        this.editForm.country = cascader[0]
        this.editForm.business_name = cascader[1]
      },
      cascaderChange(value) {
        var cascader = cascaderChange(value)
        this.params.country = cascader[0]
        this.params.business_name = cascader[1]
      },
      // 获取Cardholder list
      getdata(parameter) {
        if (parameter.static_time == null) {
          parameter.static_time = ''
        }
        if (parameter.save_time == null) {
          parameter.save_time = ''
        }
        this.loading = true
        businessBalanceList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get cardholder list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true
        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.static_time = this.timestampToTimeM(row.static_time)
          this.editForm.country = row.country
          this.editForm.business_name = row.business_name
          this.editForm.balance = row.balance
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.static_time = ''
          this.editForm.balance = ''
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        if (!this.editForm.business_name) {
          this.$message.error('Please select a business')
          return
        }
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            businessBalanceSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Cardholder save succeeded!'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            this.loading = false
            return false
          }
        })
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {}
      },
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/business/business_balance.vue